/**
 * This is the entry point for the game.
 */
import { Game } from './Game';

Game.init();
